

<template>
  <div class="nav_container">
    <div class="header_box">
      <div class="logo">
        <router-link :to="{ name: 'home' }">
          <img :src="CompanyInfo.email" />
        </router-link>
      </div>
      <div class="tabbar">
        <LangCom></LangCom>
        <div class="navBox">
          <ul>
            <li>
              <router-link :to="{ name: 'home' }"
                :class="['item', ($route.meta.nav == 'about' || $route.meta.nav == 'home')? 'curr' : '']">{{$t('header.about')}}</router-link>
            </li>
            <li class="hoverNav">
              <el-popover popper-class="hoverCon" trigger="hover" width="auto">
                <nav class="navbar">
                  <div class="dropdown-menu">
                    <template v-for="(item, index) in industry_list">
                      <router-link class="item" :to="{ name: 'product', params: { id: item.id } }" :key="index">
                        <div class="ico">
                          <img :src="item.icon">
                        </div>
                        <div class="name" v-if="currentLang=='zh'">{{ item.title }}</div>
                        <div class="name" v-else>{{ item.enTitle }}</div>
                      </router-link>
                    </template>
                  </div>
                </nav>
                <router-link slot="reference" :to="{ name: 'product', params: { id: 1 } }"
                  :class="['item', $route.meta.nav == 'product' ? 'curr' : '']">{{$t('header.product')}}</router-link>
              </el-popover>
            </li>
            <li>
              <router-link :to="{ name: 'esg' }"
                :class="['item', $route.meta.nav == 'esg' ? 'curr' : '']">ESG</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'news' }"
                :class="['item', $route.meta.nav == 'news' ? 'curr' : '']">{{$t('header.news')}}</router-link>
            </li>
            <li v-if="CompanyInfo.tel!='false'">
              <router-link :to="{ name: 'join' }"
                :class="['item', $route.meta.nav == 'join' ? 'curr' : '']">{{$t('header.join')}}</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'contact' }"
                :class="['item', $route.meta.nav == 'contact' ? 'curr' : '']">{{$t('header.contact')}}</router-link>
            </li>
          </ul>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import LangCom from './LangCom.vue'
import { Popover } from 'element-ui'
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      CompanyInfo: {},
      isNavbarVisible: false, // 默认为不显示导航栏
      industry_list: {},
      currentLang:this.$i18n.locale
    };
  },
  components: {
    LangCom,
    [Popover.name]: Popover
  },
  mounted() {
    this.addEventListeners();
  },
  created: function () {
    this.GetInfo();
    this.GetCat();
  },
  methods: {
    ...mapActions([
      'setCategoryList',
      'setCompanyInfo'
    ]),
    GetInfo() {
      var url = "/pageapi/common/GetCompanyInfo";
      this.$http.post(url, {}).then(
        function (res) {
          if (res.data.status == 1) {
            this.CompanyInfo = res.data.ds;
            this.setCompanyInfo(res.data.ds);

          }
        }.bind(this)
      )
        .catch(function (error) { });
    },
    addEventListeners() {
      const container = document.querySelector('.hoverNav');
      container.addEventListener('mouseover', () => {
        this.isNavbarVisible = true; // 鼠标进入时显示导航栏
      });
      container.addEventListener('mouseout', () => {
        this.isNavbarVisible = false; // 鼠标移开时隐藏导航栏
      });
    },
    GetCat() {
      var url = "/pageapi/Product/GetCat";
      this.$http.post(url, {}).then(function (res) {
        if (res.data.status == 1) {
          
          this.industry_list = res.data.ds;
          this.setCategoryList(res.data.ds);
        }
      }.bind(this)).catch(function () {
      });
    },
  }
};
</script>
